import {
    SET_HOLIDAYS_LOADING,
    SET_HOLIDAYS,
} from "actions/holidays";

const initialState = {
    loading: false,
    list: [],
    error: null
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_HOLIDAYS:
            return {
                ...state,
                list: action.payload,
            };
        case SET_HOLIDAYS_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        default:
            return state;
    }
};

export default reducer;